import React, { useState, useEffect, useMemo, useCallback } from "react";
// import Select from "react-select";
// import { Select, MenuItem, TextField, Button } from '@mui/material';
import {
  Button,
  MenuItem,
  Select,
  TextField,
  FormControl,
  InputLabel,
} from "@mui/material";
import Autocomplete from "@mui/lab/Autocomplete";
import moment from "moment-timezone";
import MUIDataTable from "mui-datatables";
import secureLocalStorage from "react-secure-storage";
import Axios from "axios";
import "./muitab.css";

function Carton_status() {
  const getDefaultFromDate = () =>
    moment().subtract(3, "months").format("YYYY-MM-DD");
  const getDefaultToDate = () => moment().format("YYYY-MM-DD");

  const isLoggedIn = secureLocalStorage.getItem("isLoggedIn");
  const [order_id, setorderids] = useState([]);
  const [selectedOption1, setSelectedOption1] = useState([]);
  const [articleList, setArticleList] = useState([]);
  const [selectedArticle, setArticle] = useState("");
  const [shadeList, setShadeList] = useState([]);
  const [selectedShade, setShade] = useState("");
  const [fromDate, setFromDate] = useState(getDefaultFromDate);
  const [toDate, setToDate] = useState(getDefaultToDate);
  const mill = secureLocalStorage.getItem("mill");
  const token = secureLocalStorage.getItem("token");
  const [offset, setOffset] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedvalue, setselectedvalue] = useState("10");
  const [totalRecords, setTotalRecords] = useState(0);
  const [details, setDetails] = useState([]);

  const getAuthHeaders = useCallback(
    () => ({
      headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    }),
    [token],
  );

  const statusOptions = useMemo(
    () => ["Generated Label", "Carton Printed", "Carton RePrinted"],
    [],
  );
  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }

    const getAllDetails = () => {
      if (mill == "COATS") {
        Axios.post(
          `${process.env.REACT_APP_API_URL}/order/order_disp1`,
          {},
          getAuthHeaders(),
        ).then((response) => {
          setorderids(response.data);
        });
      } else {
        Axios.post(
          `${process.env.REACT_APP_API_URL}/order/order_disp_vendor1`,
          {
            mill: mill,
          },
          getAuthHeaders(),
        ).then((response) => {
          setorderids(response.data);
        });
      }
    };

    getAllDetails();

    Axios.post(
      `${process.env.REACT_APP_API_URL}/label/article_disp`,
      {},
      getAuthHeaders(),
    ).then((response) => {
      setArticleList(response.data);
    });

    Axios.post(
      `${process.env.REACT_APP_API_URL}/label/shade_disp`,
      {},
      getAuthHeaders(),
    ).then((response) => {
      setShadeList(response.data);
    });
  }, [getAuthHeaders, isLoggedIn, mill]);

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }

    if (
      selectedvalue !== "10" ||
      offset !== 0 ||
      page !== 1 ||
      pageSize !== 10
    ) {
      combo_filter();
    }
  }, [isLoggedIn, selectedvalue, offset, page, pageSize]);
  const format_date = useCallback((utcDate) => {
    const istDate = moment.utc(utcDate).tz("Asia/Kolkata").format("YYYY-MM-DD");
    return istDate;
  }, []);

  const columns = useMemo(
    () => [
      { name: "carton_no", label: "Carton No" },
      { name: "po_number", label: "PO Number" },
      {
        name: "sap_order_date",
        label: "PO Date",
        options: {
          customBodyRender: (value) => format_date(value),
        },
      },
      { name: "mill", label: "Mill" },
      { name: "article", label: "Article" },
      {
        name: "material",
        label: "Material",
        options: {
          customBodyRenderLite: (dataIndex) => {
            const row = details?.[dataIndex] || {};
            const articleValue = row.article || "";
            const shadeValue = row.shade || "";
            return [articleValue, shadeValue].filter(Boolean).join("-");
          },
        },
      },
      { name: "depot", label: "Depot" },
      { name: "fullqty", label: "Quantity" },
      { name: "packerid", label: "Packer ID" },
      { name: "grosswt", label: "Gross Weight" },
      // {name:"greykg",label:"Net Weight"},
      { name: "cartontype", label: "Carton Type" },
      { name: "statuscode", label: "Status" },
      {
        name: "carton_date",
        label: "Carton Date",
        options: {
          customBodyRender: (value) => format_date(value),
        },
      },
      { name: "count_label", label: "Count Label" },
    ],
    [details, format_date],
  );
  const articleOptions = useMemo(() => {
    return articleList.map((item) => ({
      label: item.material_code,
      value: item.material_code,
    }));
  }, [articleList]);

  const shadeOptions = useMemo(() => {
    const seen = new Set();
    const uniqueOptions = [];

    for (const item of shadeList) {
      const shadeValue = item.shade;
      if (!seen.has(shadeValue)) {
        seen.add(shadeValue);
        uniqueOptions.push({ label: shadeValue, value: shadeValue });
      }
    }

    return uniqueOptions;
  }, [shadeList]);

  const articleOptionsByValue = useMemo(() => {
    return new Map(articleOptions.map((option) => [option.value, option]));
  }, [articleOptions]);

  const shadeOptionsByValue = useMemo(() => {
    return new Map(shadeOptions.map((option) => [option.value, option]));
  }, [shadeOptions]);

  const selectedArticleOption = useMemo(() => {
    return articleOptionsByValue.get(selectedArticle) || null;
  }, [articleOptionsByValue, selectedArticle]);

  const selectedShadeOption = useMemo(() => {
    return shadeOptionsByValue.get(selectedShade) || null;
  }, [shadeOptionsByValue, selectedShade]);
  //   const handleArticleChange = (event) => {
  //     const selectedValue = event.target.value;
  //     setArticle(selectedValue);
  //     console.log('Selected Article:', selectedValue);
  //   };
  const handleArticleChange = useCallback((event, newValue) => {
    if (newValue) {
      setArticle(newValue.value); // Update with the selected option's value
    } else {
      setArticle(""); // Reset the state if no option is selected
    }
  }, []);
  //   const handleShadeChange = (event) => {
  //     const selectedValue = event.target.value;
  //     setShade(selectedValue);
  //     console.log('Selected shade:', selectedValue);
  //   };
  const handleShadeChange = useCallback((event, newValue) => {
    if (newValue) {
      setShade(newValue.value); // Update with the selected option's value
    } else {
      setShade(""); // Reset the state if no option is selected
    }
  }, []);
  const handlesetFromDate = useCallback((event) => {
    setFromDate(event.target.value || getDefaultFromDate());
  }, []);

  const handlesetToDate = useCallback((event) => {
    setToDate(event.target.value || getDefaultToDate());
  }, []);
  const combo_filter = async () => {
    console.log(selectedArticle);
    try {
      const effectiveFromDate = fromDate || getDefaultFromDate();
      const effectiveToDate = toDate || getDefaultToDate();

      console.log(selectedArticle);
      const { data } = await Axios.post(
        `${process.env.REACT_APP_API_URL}/label/carton_status`,
        {
          // statuscode: selectedOrderstatuscode,
          date1: effectiveFromDate,
          date2: effectiveToDate,
          // article:selectedArticle?.value,
          // shade:selectedShade?.value,
          article: selectedArticle,
          shade: selectedShade,
          mill: mill,
          status: selectedOption1,
          value1: Number(selectedvalue),
          // offset: offset,
          page: page, // Pass current page
          pageSize: pageSize,
        },
        {
          ...getAuthHeaders(),
        },
      );
      const totalCount = data.totalCount;
      const response = data.result;
      console.log("totalCount", totalCount);
      console.log("response", response);
      var len;
      if (page === 1) {
        // Reset the details state if it's the first page
        console.log("length", response.length);
        for (len = 0; len < response.length; len++) {
          console.log("response[len].cartontype", response[len].cartontype);
          if (response[len].cartontype === "Solid") {
            console.log("response[len].fullqty", response[len].fullqty);
            response[len].fullqty = response[len].at_cc;
            console.log("response[len].fullqty", response[len].fullqty);
          }
          if (response[len].cartontype === "Loose") {
            const grossWeight = (
              (response[len].grosswt / response[len].at_cc) *
              response[len].fullqty
            ).toFixed(1);
            response[len].grosswt = grossWeight;
          }
        }
        setDetails(response);
      } else {
        // Append new data to the existing details state
        for (len = 0; len < response.length; len++) {
          console.log("response[len].cartontype", response[len].cartontype);
          if (response[len].cartontype === "Solid") {
            console.log("response[len].fullqty", response[len].fullqty);
            response[len].fullqty = response[len].at_cc;
            console.log("response[len].fullqty", response[len].fullqty);
          }
          if (response[len].cartontype === "Loose") {
            const grossWeight = (
              (response[len].grosswt / response[len].at_cc) *
              response[len].fullqty
            ).toFixed(1);
            response[len].grosswt = grossWeight;
          }
        }
        setDetails((prevDetails) => [...prevDetails, ...response]);
      }
      // const uniqueRows = response.filter((newRow) => {
      //   return !details.some((existingRow) => existingRow.carton_no === newRow.carton_no);
      // });

      // setDetails((prevDetails) => [...prevDetails, ...uniqueRows]);
      console.log(response);
      setTotalRecords(totalCount);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const clear_values = useCallback(() => {
    setArticle("");
    setShade("");
    setFromDate(getDefaultFromDate());
    setToDate(getDefaultToDate());
    setSelectedOption1([]);
    setDetails([]);
    setTotalRecords(0);
  }, []);
  const handlePageChange = useCallback(
    (newPage) => {
      const newOffset = newPage * pageSize; // Calculate the new offset
      setPage(newPage + 1);
      setOffset(newOffset);
    },
    [pageSize],
  );

  const handlePageSizeChange = useCallback((newPageSize) => {
    setPageSize(newPageSize);
    setPage(1); // Reset the page to 1 when page size changes
    setOffset(0); // Reset the offset to 0 when page size changes
  }, []);

  const handleStatusChange = useCallback((event) => {
    setSelectedOption1(event.target.value);
  }, []);

  const tableOptions = useMemo(
    () => ({
      filterType: "checkbox",
      selectableRows: "none",
      download: false,
      print: false,
      viewColumns: false,
      search: false,
      sort: false,
      filter: false,
      page: page - 1,
      rowsPerPage: pageSize,
      count: totalRecords,
      onChangePage: handlePageChange,
      onChangeRowsPerPage: handlePageSizeChange,
      downloadOptions: {
        filename: "CartonStatus.csv",
        filterOptions: {
          useDisplayedColumnsOnly: true,
          useDisplayedRowsOnly: true,
        },
      },
    }),
    [page, pageSize, totalRecords, handlePageChange, handlePageSizeChange],
  );
  function downloadTable() {
    // create a new workbook
    const workbook = XLSX.utils.book_new();

    // convert the table data to a worksheet
    const worksheet = XLSX.utils.table_to_sheet(
      document.querySelector("table"),
    );

    // add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // generate a blob object containing the XLSX file data
    const blob = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

    // create a temporary link element to trigger the download
    const link = document.createElement("a");
    link.href = URL.createObjectURL(
      new Blob([blob], { type: "application/octet-stream" }),
    );
    link.download = "table.xlsx";

    // simulate a click event to trigger the download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  const downloadData = async () => {
    if (totalRecords != 0) {
      const effectiveFromDate = fromDate || getDefaultFromDate();
      const effectiveToDate = toDate || getDefaultToDate();

      var data = "";
      var len = 0;
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/label/carton_status`,
        {
          date1: effectiveFromDate,
          date2: effectiveToDate,
          article: selectedArticle,
          shade: selectedShade,
          mill: mill,
          status: selectedOption1,
          value1: Number(selectedvalue),
          page: page, // Pass current page
          pageSize: pageSize,
          download: 1,
        },
        {
          ...getAuthHeaders(),
        },
      );
      console.log("response.data", response.data);
      console.log("response.length", response.data.length);
      for (len = 0; len < response.data.length; len++) {
        console.log("response[len].cartontype", response.data[len].cartontype);
        if (response.data[len].cartontype === "Solid") {
          console.log("response[len].fullqty", response.data[len].fullqty);
          response.data[len].fullqty = response.data[len].at_cc;
          console.log("response[len].fullqty", response.data[len].fullqty);
        }
        if (response.data[len].cartontype === "Loose") {
          const grossWeight = (
            (response.data[len].grosswt / response.data[len].at_cc) *
            response.data[len].fullqty
          ).toFixed(1);
          response.data[len].grosswt = grossWeight;
        }
      }
      //  data = filteredData;
      data = response.data.map((row) => {
        return {
          carton_no: row.carton_no,
          po_number: row.po_number,
          sap_order_date: format_date(row.sap_order_date),
          mill: row.mill,
          article: row.article,
          material: [row.article, row.shade].filter(Boolean).join("-"),
          depot: row.depot,
          fullqty: Number(row.fullqty),
          packerid: row.packerid,
          grosswt: row.grosswt,
          cartontype: row.cartontype,
          statuscode: row.statuscode,
          carton_date: format_date(row.carton_date),
          count_label: row.count_label,
        };
      });

      console.log("data", data);
      console.log("data", data.length);
      if (data.length != 0) {
        const ws = XLSX.utils.json_to_sheet(data);

        const wb = XLSX.utils.book_new(); // Create a new workbook
        XLSX.utils.book_append_sheet(wb, ws, "data"); // Add the worksheet to the workbook

        // Write the workbook to a buffer
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

        // Create a Blob from the buffer
        const blob = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Create an anchor tag for downloading
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = "Carton Status Data.xlsx";

        // Trigger the download
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();

        // Clean up
        document.body.removeChild(a);
        URL.revokeObjectURL(a.href);
      }
    }
  };
  return (
    <div>
      {isLoggedIn ? (
        <>
          <br />{" "}
          <h3 style={{ marginLeft: "55px" }} data-cy="order_label">
            Carton Status
          </h3>
          <br />
          <div
            style={{
              width: "80%",
              display: "flex",
              justifyContent: "space-evenly",
              marginLeft: "50px",
            }}
          >
            <FormControl
              style={{ display: "flex", marginLeft: "-53px", width: "150px" }}
            >
              <Autocomplete
                options={articleOptions}
                value={selectedArticleOption}
                onChange={handleArticleChange}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                renderInput={(params) => (
                  <TextField {...params} label="Select Article" />
                )}
                style={{ fontSize: "12px" }}
              />
            </FormControl>

            <FormControl
              style={{ display: "flex", marginLeft: "10px", width: "150px" }}
            >
              <Autocomplete
                options={shadeOptions}
                value={selectedShadeOption}
                onChange={handleShadeChange}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                renderInput={(params) => (
                  <TextField {...params} label="Select Shade" />
                )}
                style={{ fontSize: "12px" }}
              />
            </FormControl>

            <FormControl
              style={{ display: "flex", marginLeft: "10px", width: "170px" }}
            >
              <InputLabel>Status</InputLabel>
              <Select
                multiple
                value={selectedOption1}
                onChange={handleStatusChange}
                renderValue={(selectedOption1) => (
                  <div>
                    {selectedOption1.map((value) => (
                      <div key={value}>{value}</div>
                    ))}
                  </div>
                )}
              >
                {/* <MenuItem value="Generated Label">Generated Label</MenuItem>
          <MenuItem value="Carton Printed">Carton Printed</MenuItem>
          <MenuItem value="Carton RePrinted">Carton RePrinted</MenuItem> */}
                {statusOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              label="Select From Date"
              type="date"
              value={fromDate}
              onChange={handlesetFromDate}
              style={{ display: "flex", marginLeft: "10px", width: "150px" }}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                // max: new Date().toISOString().split("T")[0], // Set the max attribute to today's date
                max: toDate ? toDate : new Date().toISOString().split("T")[0],
              }}
            />
            <TextField
              label="Select To Date"
              type="date"
              value={toDate}
              onChange={handlesetToDate}
              style={{ display: "flex", marginLeft: "10px", width: "150px" }}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                min: fromDate,
                max: new Date().toISOString().split("T")[0], // Set the max attribute to today's date
              }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setPage(1);
                setPageSize(10);
                setDetails([]);
                combo_filter();
              }}
            >
              Filter
            </Button>
            <Button variant="contained" color="primary" onClick={clear_values}>
              Clear
            </Button>
          </div>
          <br />
          {/* <div style={{ width: '100%' }}> */}
          {details.length > 0 && (
            <div>
              <div
                style={{
                  width: "95%",
                  display: "flex",
                  justifyContent: "right",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={downloadData}
                  //  onClick={() => fileInputRef.current.click()}
                >
                  Download
                </Button>
              </div>
              <br />
              <div
                style={{
                  marginLeft: "55px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  maxWidth: "93%",
                }}
              >
                <MUIDataTable
                  // data={details}
                  data={details}
                  columns={columns}
                  options={tableOptions}
                  className="custom-table"
                />
              </div>
            </div>
          )}
        </>
      ) : (
        (window.location.href = "#/login")
      )}
    </div>
  );
}
export default Carton_status;
